<template>
  <div class="row">
    <div class="flex xs12">
      <va-card title="名企一对一列表">
        <div class="row align--center mb-1">
          <div class="flex xs12 sm6">
            <va-input
              class="ma-0"
              :value="titleName"
              placeholder="search by title"
              @input="search"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <div class="flex xs12 sm6">
            <div class="d-flex justify--end">
              <va-button color="info" small :to="{ name: 'saveEnterpriseToOne' }">新增名企</va-button>
            </div>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="filteredData"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listEnterpriseToOne"
          api-mode
        >
          <template slot="cover" slot-scope="props">
            <img :src="props.rowData.imageUrl" class="data-table-server-pagination---avatar" alt="avatar">
          </template>
          <template slot="sort" slot-scope="props">
            <va-input
              v-model="props.rowData.sortNum"
              type="number"
              :min="1"
            >
              <va-button slot="append" icon="ion-md-checkmark ion" color="info" small @click="updateSortNum(props.rowData)">
              </va-button>
            </va-input>
          </template>
          <template slot="actions" slot-scope="props">
            <va-button flat small color="gray" icon="fa fa-pencil"
              :to='{path:`updateEnterpriseToOne/${props.rowData.id}`}'/>
            <va-button flat small color="gray" icon="fa fa-trash"
              @click="deleteModal = true;deleteId=props.rowData.id"/>
          </template>
        </va-data-table>
        <va-modal
          v-model="deleteModal"
          title="删除名企一对一"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />
      </va-card>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce'
import enterpriseToOne from '../../api/enterpriseToOne'

export default {
  data () {
    return {
      message: ['Required field'],
      serviceId: 2,
      enterpriseToOnes: [],
      titleName: '',
      loading: true,
      pageSize: 10,
      totalPages: 1,
      deleteModal: false,
      deleteId: null,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:cover',
          width: '60px',
        }, {
          name: 'title',
          title: '工作岗位',
          width: '15%',
        },
        {
          name: '__slot:sort',
          title: '排序',
          width: '10%',
        },
        {
          name: 'projectDuration',
          title: '项目周期',
          width: '15%',
        },
        {
          name: 'description',
          title: '项目描述',
          width: '50%',
        },
        {
          name: '__slot:actions',
          width: '10%',
          dataClass: 'text-left',
        },
      ]
    },
    filteredData () {
      if (!this.titleName || this.titleName.length < 1) {
        return this.enterpriseToOnes
      }
      return this.enterpriseToOnes.filter(item => {
        return item.title.toLowerCase().startsWith(this.titleName.toLowerCase())
      })
    },
  },
  created () {
    this.listEnterpriseToOne()
  },
  methods: {
    listEnterpriseToOne (pageNumber = 1) {
      this.loading = true
      const params = {
        serviceId: this.serviceId,
        pageSize: this.pageSize,
        pageNumber: pageNumber,
      }
      enterpriseToOne.listEnterpriseToOne(params)
        .then(response => {
          this.enterpriseToOnes = response.enterpriseToOnes
          this.totalPages = response.totalPage
          this.loading = false
        })
    },
    confirmDelete () {
      if (this.deleteId === null) return
      enterpriseToOne.deleteEnterpriseToOne(this.deleteId).then(response => {
        if (response.success === true) {
          this.listEnterpriseToOne()
        }
      }).catch(error => alert(error))
    },
    search: debounce(function (titleName) {
      this.titleName = titleName
    }, 400),
    updateSortNum: function (params) {
      enterpriseToOne.updateEnterpriseToOne(params.id, params).then(response => {
        if (response.success === true) {
          this.listEnterpriseToOne()
        }
      }).catch(error => alert(error))
    },
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 5%;
}
</style>
